{
  "sidenavMenuCloseTooltip": "Chiudi menu",
  "sidenavMenuLockTooltip": "Fai clic per bloccare il menu",
  "toggleSideNav": "Attiva/Disattiva il menu di navigazione laterale"
}
